export default "__VITE_ASSET__Dk$ASabr__"